import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Dialogs extends Component {

  close() {
    this.setState({
      dialog: false
    })
    this.props.closedialog();
  }

  

  render() {
    return (
      <div>
        <Dialog open={true} aria-labelledby="responsive-dialog-title">
          <DialogTitle id="responsive-dialog-title" id="widthdialog">{"Success"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div style={{color: 'black'}}>{this.props.message}</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.close.bind(this)}variant="outlined" color="secondary">Okay</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Dialogs;
